import { useContext } from 'react';
import { AssetUploadContext } from './AssetUploadContext';

export const useAssetUploadContext = () => {
  const context = useContext(AssetUploadContext);
  if (!context) {
    throw new Error('useUploadContext must be used within an UploadProvider');
  }
  return context;
};
